<template>
  <el-dialog v-loading="loading.dialog" class="toRelease_model_dialog" top="5vh" center
    :title="'【' + formInfo.taskInfo.pid + '.' + formInfo.taskInfo.id + '】' + '待发布'" width="90%"
    :before-close="handleClose" :visible.sync="dialogVisible" :close-on-click-modal="false">
    <el-form ref="form" size="mini" :rules="rules" :model="form">
      <div style="display: flex">
        <el-form-item label="主域名" prop="domain" :label-width="formLabelWidth">
          {{ allSelect.TEXTDOMAINS[form.domain] }}
        </el-form-item>
        <el-form-item label="系统" label-width="65px">
          {{ allSelect.TEXTMODULES[form.module] }}
        </el-form-item>
      </div>
      <div style="display: flex">
        <el-form-item label="产品" :label-width="formLabelWidth">
          {{ allSelect.TEXTUSERS[form.user_pm] }}
        </el-form-item>
        <el-form-item label="开发" label-width="65px">
          {{ allSelect.TEXTUSERS[form.user_rd] }}
        </el-form-item>
        <el-form-item label="测试" label-width="65px">
          {{ allSelect.TEXTUSERS[form.user_qa] }}
        </el-form-item>
        <el-form-item label="技术评审员" label-width="100px">
          {{ techReviewerCh }}
        </el-form-item>
      </div>
      <div style="display: flex;" v-if="!nonStandard">
        <el-form-item label="上线分支" :label-width="formLabelWidth">
          <div>
            {{ form.master_branch || 'master' }}
          </div>
        </el-form-item>
        <el-form-item label="开发分支" :label-width="formLabelWidth">
          <div style="text-decoration: underline;color: #409EFF;cursor: pointer;"
            @click="openLink(form.branch_web_url_prefix + form.branch)">
            {{ form.branch }}
          </div>
        </el-form-item>
      </div>
      <el-form-item label="额外部署SQL文件" prop="env" :label-width="formLabelWidth">
        <el-button type="primary" @click="handleSqlDialogVisible('edit')">查看 / 编辑
        </el-button>
      </el-form-item>
      <el-form-item label="发布窗口" prop="pdt" :label-width="formLabelWidth">
        <el-date-picker value-format="timestamp" v-model="form.pdt" align="right" :default-time="'12:00:00'"
          type="datetime" placeholder="选择日期时间" :picker-options="pickerOptions">
        </el-date-picker>
        <span style="color: red;font-size: 12px;">注：所有系统发布窗口（18：00），其他时间点为非标发布</span>
      </el-form-item>
      <el-form-item label="是否sql部署" prop="pdt_leader_proof" :label-width="formLabelWidth">
        <el-radio v-model="form.extradeploy_switch" label="on">是</el-radio>
        <el-radio v-model="form.extradeploy_switch" label="off">否</el-radio>
      </el-form-item>
      <el-form-item label="是否代码发布" prop="pdt_leader_proof" :label-width="formLabelWidth">
        <el-radio v-model="form.codedeploy_switch" :disabled="nonStandard" label="on">是</el-radio>
        <el-radio v-model="form.codedeploy_switch" :disabled="nonStandard" label="off">否</el-radio>
      </el-form-item>
      <el-form-item label="是否紧急发布" prop="pdt_leader_proof" :label-width="formLabelWidth">
        <el-radio v-model="form.urgentdeploy_switch" label="on">是</el-radio>
        <el-radio v-model="form.urgentdeploy_switch" label="off">否</el-radio>
      </el-form-item>
      <el-form-item label="发布请示证明" prop="pdt_leader_proof" :label-width="formLabelWidth">
        <el-upload class="upload-demo" action="https://devops-test.ehsy.com/devops/common/upload"
          :on-preview="handlePreview" :before-remove="beforeRemove" multiple :limit="3" :on-success="handleSuccess"
          :on-remove="handleRemove" :file-list="fileList">
          <el-button size="mini" type="primary">点击上传</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="warning" :loading="loading.toRelease" :disabled="!form.pdt"
        @click="dialog.releaseTipVisible = true">提交发布申请</el-button>
      <el-button type="warning" v-if="isFirstApply" :disabled="!form.pdt" :loading="loading.toCancel"
        @click="dialog.releaseCancelTipVisible = true">取消发布申请</el-button>
    </div>
    <!--  #region dialogVisible 部分 -->
    <el-dialog :close-on-click-modal="false" custom-class="toRelease_model_dialog_child" width="80%" center
      title="额外部署SQL文件" :visible.sync="dialog.sqlVisible" append-to-body>
      <Codemirror v-if="dialog.sqlVisible" style="margin-bottom: 10px" sqlStyle="height:200px;" ref="sqlFileditor"
        :value="form.sqlExtracontent" @changeTextarea="changeTextarea($event, 'sqlExtracontent')" />
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSqlDialogVisible('save')">保存</el-button>
        <span style="font-size: 15px;color: #666;font-weight: bold;margin-left: 10px;position: absolute;bottom: 30px;"
          v-if="sqlQualityTestInfo.score < 100">
          分数:<span :style="{ color: sqlQualityTestInfo.score > 90 ? '#67C23A' : '#E6A23C' }">{{ sqlQualityTestInfo.score
          }}</span><a style="color: rgb(64, 158, 255);margin-left: 20px;" :href="sqlQualityTestInfo.origin_url"
            target="_blank" v-if="sqlQualityTestInfo.origin_url">查看报告</a>
        </span>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" custom-class="toRelease_model_dialog_child" center title="发布日志"
      :visible.sync="dialog.toReleaseVisible" width="80%" append-to-body left>
      <pre v-if="msg.toReleaseMsg" v-html="msg.toReleaseMsg" class="tips-message"></pre>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="dialog.releaseTipVisible" width="30%" center append-to-body>
      <div style="text-align:center;">是否确认提交发布申请？</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" :loading="loading.toRelease" @click="submit('run')">提交发布申请</el-button>
        <el-button type="primary" @click="dialog.releaseTipVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="dialog.releaseCancelTipVisible" width="30%" center append-to-body>
      <div style="text-align:center;">是否确认取消发布申请？（注：取消后请手动将合并到主分支的代码撤销）</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" :loading="loading.toCancel" @click="submit('cancel')">取消发布申请</el-button>
        <el-button type="primary" @click="dialog.releaseCancelTipVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!--  #endregion -->
  </el-dialog>
</template>
<script>
import {
  getDevOpsSpaceListStageParmApi,
  getEdiApi,
  postUpdateEdiApi,
  postDevopsSpaceStageActionApi
} from "@/server/tops/devOps";
import { Codemirror } from "@/components";
import { mapState } from "vuex";
export default {
  components: { Codemirror },
  props: {
    formInfo: {
      type: Object,
      default: function () {
        return {};
      },
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { };
      },
    },
  },
  data() {
    return {
      form: {
        sqlExtracontent: "",
        domain: "",
        extradeploy_switch: 'on',
        codedeploy_switch: 'on',
        urgentdeploy_switch: 'off'
      },
      rules: {
        pdt: {
          required: true,
          message: "必填",
          trigger: "change",
        },
      },
      formLabelWidth: "130px",
      dialog: {
        sqlVisible: false,
        toReleaseVisible: false,
        releaseCancelTipVisible: false,
        releaseTipVisible: false
      },
      loading: {
        toRelease: false,
        toCancel: false,
        dialog: true
      },
      msg: {
        toReleaseMsg: "",
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 60 * 60 * 24 * 1000;
        },
        shortcuts: [
          {
            text: "当天12:00",
            onClick: (picker) => {
              const day = this.$moment(new Date()).format("YYYY-MM-DD");
              const date = new Date(day + " 12:00:00");
              picker.$emit("pick", date);
            },
          },
          {
            text: "当天17:30",
            onClick: (picker) => {
              const day = this.$moment(new Date()).format("YYYY-MM-DD");
              const date = new Date(day + " 17:30:00");
              picker.$emit("pick", date);
            },
          },
          {
            text: "当天18:00",
            onClick: (picker) => {
              const day = this.$moment(new Date()).format("YYYY-MM-DD");
              const date = new Date(day + " 18:00:00");
              picker.$emit("pick", date);
            },
          },
        ]
      },
      fileList: [],
      isFirstApply: false, // 判断是否是第一次提交 true 不是第一次提交 false 是第一次提交
      sqlQualityTestInfo: {}
    };
  },
  async created() {
    const {
      user_pm,
      user_qa,
      module = "",
      user_rd,
      id = "",
      pid = "",
      tech_reviewer = "",
      domain = ""
    } = this.formInfo?.taskInfo || {};
    this.form = { ...this.form, id, pid, user_pm, user_qa, module, user_rd, tech_reviewer, domain };
    await this.queryDevOpsSpaceListStageParmInfo();
  },
  computed: {
    ...mapState({
      allSelect: (state) => state.devOps.ALLSELECT,
    }),
    techReviewerCh() {
      let names = '';
      this.form.tech_reviewer.split(",").forEach((item) => {
        if (this.allSelect.TEXTUSERS[item]) {
          if (this.allSelect.TEXTUSERS[item]) {
            names += this.allSelect.TEXTUSERS[item] + ' '
          }
        }
      })
      return names || '';
    },
    nonStandard() { // 非标系统标识
      const nonStandard = this.form.module.startsWith('非标-');
      if (nonStandard) {
        this.form.codedeploy_switch = 'off';
      }
      return nonStandard;
    }
  },
  methods: {
    // 获取开发中任务阶段设置信息
    async queryDevOpsSpaceListStageParmInfo() {
      try {
        const { id = "", pid = "" } = this.form;
        const ret = await getDevOpsSpaceListStageParmApi({
          stage_id: "21",// 21
          task_id: id,
          pid,
        });
        if (ret.status === "success") {
          const { common_branch: branch, pdt = '', branch_web_url_prefix = '', master_branch = '', pdt_leader_proof = '[]', extradeploy_switch = 'on', codedeploy_switch = 'on', urgentdeploy_switch = 'off' } = ret.data || {};
          const newPdt =  () => {
            const day = this.$moment(new Date()).format("YYYY-MM-DD");
            const date = new Date(day + " 18:00:00");
            return date.getTime();
          }
          this.form = {
            ...this.form,
            branch,
            branch_web_url_prefix,
            pdt: pdt || newPdt(),
            master_branch,
            extradeploy_switch,
            codedeploy_switch,
            urgentdeploy_switch
          };
          this.isFirstApply = pdt;
          this.fileList = (pdt_leader_proof ? JSON.parse(pdt_leader_proof) : []);
        } else {
          this.$notify({
            message: ret.error || "数据错误",
            type: "error",
          });
        }
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        });
      } finally {
        this.loading.dialog = false
      }
    },
    // 关闭弹窗
    handleClose(step) {
      this.hideDialogVisible(step);
    },
    //设置sql语句
    changeTextarea(val, type) {
      this.$set(this.form, type, val);
    },
    // 编辑额外部署sql文件
    async handleSqlDialogVisible(type) {
      const { id, pid } = this.form;
      let ret = {};
      try {
        switch (type) {
          case "edit":
            ret = await getEdiApi({ id, pid });
            this.form.sqlExtracontent = ret.data || "";
            this.sqlQualityTestInfo = {};
            break;
          case "save":
            ret = await postUpdateEdiApi({
              id,
              content: this.form.sqlExtracontent,
              pid,
            });
            break;
          default:
            break;
        }
        if (ret.status === "success") {
          this.dialog.sqlVisible = type === "edit" ? true : false;
        } else {
          if (type === 'save') {
            this.sqlQualityTestInfo = ret.data.data;
            this.dialog.sqlVisible = true;
            this.$notify({
              message: "保存失败",
              type: "error",
            });
            return;
          };
          this.$notify({
            message: "数据错误",
            type: "error",
          });
        }
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        });
      }
    },
    // 打开外链接
    openLink(url) {
      window.open(url);
    },
    // 完成发布
    async submit(type) {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          const loadingType = type === 'run' ? 'toRelease' : 'toCancel';
          this.loading[loadingType] = true;
          this.dialog.releaseTipVisible = false;
          this.dialog.releaseCancelTipVisible = false;
          const pdt_leader_proof = JSON.stringify(this.fileList)
          const {
            id = '',
            pid = '',
            branch = '',
            user_rd = '',
            user_pm = '',
            user_qa = '',
            module = '',
            pdt = '',
            extradeploy_switch = '',
            codedeploy_switch = '',
            urgentdeploy_switch = ''
          } = this.form;
          let param = {
            action: type,
            stage_id: 21,
            stage_name: "operator_prodWaitDeploy",
            task_id: id,
            pid,
            branch,
            user_rd,
            user_pm,
            user_qa,
            module,
            pdt: loadingType === 'toCancel' ? 0 : pdt,
            pdt_leader_proof,
            extradeploy_switch,
            codedeploy_switch,
            urgentdeploy_switch
          };
          try {
            const ret = await postDevopsSpaceStageActionApi(param);
            const output = ret.data.output;
            if (typeof output === 'string') {
              this.msg.toReleaseMsg = JSON.stringify(ret.data || "", null, 2);
              this.$notify({
                message: output || '数据错误',
                type: 'error'
              })
            } else {
              const { code, msg } = output.waitdeploy[0]
              if (code === 0) {
                if (loadingType === 'toCancel') {
                  const day = this.$moment(new Date()).format("YYYY-MM-DD");
                  const date = new Date(day + " 18:00:00");
                  this.form.pdt = date.getTime();
                }
                this.isFirstApply = (loadingType === 'toRelease');
              }
              this.$notify({
                message: msg || '数据错误',
                type: code === 0 ? 'success' : 'error'
              })
            }
          } catch (error) {
            this.$notify({
              message: error || '数据错误',
              type: 'error'
            })
          } finally {
            this.loading.toRelease = false;
            this.loading.toCancel = false;
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      })
    },
    handlePreview(file) {
      window.open(file?.response?.url || '')
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleSuccess(response, file, fileList) {
      this.fileList = fileList;
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
    }
  },
};
</script>
<style lang="scss">
.toRelease_model_dialog {
  .el-dialog__body {
    padding-bottom: 0;
  }
}

.toRelease_model_dialog_child {
  .el-dialog__body {
    padding: 0 20px 10px;
  }
}
</style>
